
import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { routerActions } from 'react-router-redux'
import TextField from 'material-ui/TextField'
import Slider from 'material-ui/Slider'
import Checkbox from 'material-ui/Checkbox'
import DatePicker from 'material-ui/DatePicker'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import {List, ListItem} from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import Colors from 'material-ui/styles/colors'
import Divider from 'material-ui/Divider'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import AutoComplete from 'material-ui/AutoComplete'
import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem'
import SelectField from 'material-ui/SelectField';
import Moment from 'moment'
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton'
import Error from 'components/Error'
import Deleted from 'components/Deleted'
import newCommentActions from 'actions/newCommentActions'
import { sort, sortSev, sortTasks } from 'utils/stuff'
import dataActions from 'actions/dataActions'
import AttachmentRender from 'components/AttachmentRender'
import attachmentActions from 'actions/attachmentActions'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import rightStackActions from 'actions/rightStackActions'
import EntityAttachments from 'components/EntityAttachments'
;
import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'
import TaskList from 'components/TaskList'
import actionBarActions from 'actions/actionbar'
import { dirtyRead, doc } from 'selectors/common'
import { property, manager } from 'selectors/quotes'
import formatPhone from 'utils/formatPhone'
import env from 'utils/env'
import ReactTooltip from 'react-tooltip'

let select = dirtyRead(
	(state, props) => {
		let quote = state.data.db[props.id || props.routeParams.id] || {}
		return {
			quote: doc(state, quote._id)
		  , project: doc(state,  quote.projectID)
		  , repairman: doc(state,  quote.vendorID)
		  , property: property(state, quote.projectID)
		  , manager: manager(state, quote.projectID)
		  , login: state.session.userID
		}
	}
)

let url = (env == "prod")? "https://lumand.com/": ("https://" + env + ".lumand.com/")

export class QuoteForm extends Component {
	render(){
		let { props } = this
		let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
		let quote = props.quote || {}
		let quoteId = quote._id
		let repairman = props.repairman || {}
		let repairmanId = repairman._id
		let project = props.project
		let property = props.property
		let date = (props.quote && props.quote.date)? new Date(props.quote.date): undefined
		let total = (quote.expenses && quote.expenses.length)?quote.expenses.reduce((a, b) => a + (b.amount || 0), 0): ""
		try {
			return(
				<div
					key={quoteId}
				>
					<header
						style={{
							width: "100%"
						  , height: "60px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						}}
						className="action-bar form-holder"
					>
							{(typeof global.md.phone() == 'string')?
								<div
									style={{
										width: "inherit"
									  , height: "inherit"
									}}
								>
									<img
										src={"/manager/static/img/hamburger.png"}
										style={{
											maxHeight: "20%"
										  , verticalAlign: "middle"
										  , marginLeft: "21px"
										}}
										onTouchTap={this.props.TOOGLE_LEFT_NAV}
									/>
									<span
										style={{
											overflow: "hidden"
										  , textOverflow: "ellipsis"
										  , whiteSpace: "nowrap"
										  , display: "inline-block"
										  , width: "50%"
										  , verticalAlign: "middle"
										  , marginLeft: "8%"
										}}
									>
										{ (project.title)? project.title: "Title" }
									</span>
									<div
										style={{
											float: "right"
										  , width: "15%"
										  , textAlign: "right"
										  , height: "inherit"
										}}
									>
										<img
											src={"/manager/static/img/trash.png"}
											style={{
												maxHeight: "40%"
											  , verticalAlign: "middle"
											  , marginRight: "21px"
											}}
											onClick={()=> {
												this.props.DOC_DELETE(quoteId)
												props.goBack()
											}}
										/>
									</div>
								</div>
								:
									<div id="close-quote-specs"
										style={{
											lineHeight: "60px"
										}}
									>
										<svg
											width="17px"
											height="17px"
											viewBox="0 0 17 17"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
											xmlnsXlink="http://www.w3.org/1999/xlink"
											style={{
												verticalAlign: "middle"
											  , marginLeft: "23px"
											  , marginTop: "-4px"
											  , cursor: "pointer"
											}}
											onTouchTap={ props.goBack }
										>
										    <title>Group</title>
										    <defs></defs>
										    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
										        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
										            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
										        </g>
										    </g>
										</svg>
										<span
											style={{
												fontSize: "24px"
											  , marginTop: "-2px"
											  , marginLeft: "22px"
											  , fontWeight: "800"
											  , verticalAlign: 'middle'
											  , display: "inline-block"
											  , width: "calc(100% - 36px - 50px)"
											  , textAlign: "left"
											}}
										>
											{(project && project.title)? project.title: "Title"}
										</span>
										{(quote)?
											<svg
												width="18px"
												height="21px"
												viewBox="0 0 49 59"
												version="1.1"
												xmlns="http://www.w3.org/2000/svg"
												xmlnsXlink="http://www.w3.org/1999/xlink"
												style={{
													verticalAlign: "middle"
												  , cursor: "pointer"
												  , marginTop: "-2px"
												  , position: "relative"
												  , right: "16px"
												}}
												onClick={() => {
													document.getElementsByClassName('Prompt')[0].style.marginLeft = 0
												}}
											>
											    <title>delete</title>
											    <defs></defs>
											    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											        <g id="delete" fill="#FFF">
											            <g id="Group">
											                <path d="M24.5,51 C25.052,51 25.5,50.553 25.5,50 L25.5,17 C25.5,16.447 25.052,16 24.5,16 C23.948,16 23.5,16.447 23.5,17 L23.5,50 C23.5,50.553 23.948,51 24.5,51 L24.5,51 Z" id="Shape"></path>
											                <path d="M14.5,51 C15.052,51 15.5,50.553 15.5,50 L15.5,17 C15.5,16.447 15.052,16 14.5,16 C13.948,16 13.5,16.447 13.5,17 L13.5,50 C13.5,50.553 13.948,51 14.5,51 L14.5,51 Z" id="Shape"></path>
											                <path d="M34.5,51 C35.052,51 35.5,50.553 35.5,50 L35.5,17 C35.5,16.447 35.052,16 34.5,16 C33.948,16 33.5,16.447 33.5,17 L33.5,50 C33.5,50.553 33.948,51 34.5,51 L34.5,51 Z" id="Shape"></path>
											                <path d="M47.5,6 L33.456,6 C33.346,4.75 32.961,2.642 31.643,1.289 C30.809,0.434 29.751,0 28.499,0 L18.5,0 C17.248,0 16.19,0.434 15.356,1.289 C14.038,2.642 13.653,4.75 13.543,6 L1.5,6 C0.948,6 0.5,6.447 0.5,7 C0.5,7.553 0.948,8 1.5,8 L3.541,8 L5.456,54.021 C5.493,55.743 6.565,59 10.364,59 L38.636,59 C42.435,59 43.507,55.743 43.543,54.042 L45.459,8 L47.5,8 C48.052,8 48.5,7.553 48.5,7 C48.5,6.447 48.052,6 47.5,6 L47.5,6 Z M16.792,2.681 C17.24,2.223 17.799,2 18.5,2 L28.499,2 C29.2,2 29.759,2.223 30.207,2.681 C31.012,3.504 31.335,4.952 31.447,6 L15.553,6 C15.665,4.952 15.988,3.504 16.792,2.681 L16.792,2.681 Z M41.544,53.979 C41.538,54.288 41.4,57 38.636,57 L10.364,57 C7.63,57 7.466,54.283 7.455,53.958 L5.542,8 L43.457,8 L41.544,53.979 L41.544,53.979 Z" id="Shape"></path>
											            </g>
											        </g>
											    </g>
											</svg>
										: ''
										}
									</div>
							}
  	  					{(quote)?
				  			<div
				  				style={{
				  					marginLeft: "102%"
				  				  , position: 'absolute'
				  				  , background: 'rgba(0,0,0,0.8)'
				  				  , padding: '11px'
				  				  , transition: 'all ease-in-out 0.3s'
				  				  , width: '100%'
				  				}}
				  				className="Prompt"
				  			>
				  				<span style={{verticalAlign: 'middle'}}>
				  					Are you sure you want to delete this item?
				  				</span>
				  				<div style={{float: "right", position:"relative", top:"-5px"}}>
				  					<FlatButton
				  						label="Yes"
				  						primary={true}
				  						onClick={()=> {
											this.props.DOC_DELETE(quoteId)
											props.goBack()
										}}
				  					/>
				  					<FlatButton
				  						label="No"
				  						secondary={true}
				  						onClick={() => {
				  							document.getElementsByClassName('Prompt')[0].style.marginLeft = "100%"
				  						}}
				  					/>
				  				</div>
				  			</div>
							:''
						}
					</header>
				<div
					style={{
					  position: "relative"
					, top: "60px"
					}}
				>
				{(!quoteId)?
					<Deleted />
					:
					<div
						style={{
								maxWidth: '800px'
							  , margin: "auto"
							  , marginTop: "0px"
							  , overflow: (isMob)? "auto" : 'hidden'
							  , height: (typeof global.md.phone() == 'string')? "calc(100vh - 72px)" : "calc(100vh - 60px)"
							  , paddingRight: "0"
						}}
						speed={0.8}
						className="area"
						contentClassName="content"
						horizontal={false}
						verticalScrollbarStyle={{
							width: "16px"
						  , borderRadius: "13px"
						  , marginLeft: "1px"
						  , backgroundImage: "url(/assets/manager/img/bar.png)"
						  , backgroundSize: "100%"
						  , backgroundRepeat: "no-repeat"
						  , backgroundColor: "#f5f6f5"
						  , backgroundPosition: "center"
						  , display: (isMob)? "none" :"auto"
						}}
						minScrollSize={30}
						verticalContainerStyle={{
							width: "18px"
						  , backgroundColor: "#cdcdcd"
						  , opacity: "1"
						  , display: (isMob)? "none" :"auto"
						}}
						// ref="right-panel"
						className={(isMob)? "mobile-right-panel": ""}
					>
						<div className="logical-block" >
							<img
								src={"/manager/static/img/svg-icon/repairmen_green.svg"}
								style={{
									width: "24px"
								  , cursor: "pointer"
								  , float: "left"
								  , margin: "1em 15px 1em 0"
								  , display: (isMob)?"none":""
								}}
								onClick={() => {
										this.props.history.push({
											pathname: `/manager/repairman/` + `${repairmanId}`
										})
									}
								}
							/>
							<TextField style={{position: "relative", width: (isMob)?"calc(100% - 24px)":"calc(100% - 104px)"}}
								id="name"

								hintStyle={{fontStyle: "italic", fontSize: "14px"}}
								fullWidth={false}
								style={{
									width: (isMob)?"calc(100% - 24px)":"370px"
								  , position: "relative"
								  , marginTop: "4px"
								  , marginLeft: "4px"
								}}
								inputStyle={{
									fontSize: "16px"
								  , fontWeight: "bold"
								}}
								underlineStyle={{
									left: "1px"
								  , borderBottom: "0px solid #b0bec4"
								}}
								defaultValue={props.quote.vendor}
								onBlur={(evt)=>{
									(evt.target.value.length)?
										this.props.STAGE({_id: quoteId, vendor: evt.target.value})
										: false
									}
								}
							/>
						</div>
						<div className="logical-block" style={{padding:"0 20pt"}}>
							<TextField style={{position: "relative", width: (isMob)?"calc(100% - 24px)":"calc(100% - 104px)"}}
								id="phone"
								floatingLabelText="Phone"
								hintStyle={{fontStyle: "italic", fontSize: "14px"}}
								fullWidth={false}
								style={{
									width: (isMob)?"calc(100% - 24px)":"370px"
								  , position: "relative"
								  , marginTop: "4px"
								  , marginLeft: "4px"
								}}
								inputStyle={{
									fontSize: "16px"
								  , fontWeight: "bold"
								}}
								underlineStyle={{
									left: "1px"
								  , borderBottom: "0px solid #b0bec4"
								}}
								floatingLabelStyle={{
									fontWeight: "100",
									fontSize: "14px"
								}}
								defaultValue={props.quote.phone}
								onBlur={(evt)=>{
									(evt.target.value.length)?
										this.props.STAGE({_id: quoteId, phone: evt.target.value})
										: false
									}
								}
							/>
							<TextField style={{position: "relative", width: (isMob)?"calc(100% - 24px)":"calc(100% - 104px)"}}
								id="email"
								floatingLabelText="Email"
								hintStyle={{fontStyle: "italic", fontSize: "14px"}}
								fullWidth={false}
								style={{
									width: (isMob)?"calc(100% - 24px)":"370px"
								  , position: "relative"
								  , marginTop: "4px"
								  , marginLeft: "4px"
								}}
								inputStyle={{
									fontSize: "16px"
								  , fontWeight: "bold"
								}}
								underlineStyle={{
									left: "1px"
								  , borderBottom: "0px solid #b0bec4"
								}}
								floatingLabelStyle={{
									fontWeight: "100",
									fontSize: "14px"
								}}
								defaultValue={props.quote.email}
								onBlur={(evt)=>{
									(evt.target.value.length)?
										this.props.STAGE({_id: quoteId, email: evt.target.value})
										: false
									}
								}
							/>
						</div>
						<div className="logical-block" style={{padding:"0 20pt"}}>
							<SelectField
								hintText = "Status"
								hintStyle={{fontStyle: "italic", fontSize: "14px"}}
								underlineStyle={{
									borderBottom: "0px solid #b0bec4"
								}}
								floatingLabelText="Status"
								iconStyle={{
									top: "16px"
								  , right: "-10px"
								}}
								style={{
									marginLeft: "4px"
								  , color: "#000000"
								}}
								labelStyle = {{
									display: "table"
								  , textAlign: "left"
								  , color: "#000000"
								  , fontSize: "16px"
								  , fontWeight: "bold"
								}}
								onChange={(evt, indx, value) =>
									this.props.STAGE({
										_id: quoteId
									  , status: value
									})
								}
								value={quote.status}
							>
								<MenuItem key={1} value={"new"} primaryText="New" />
								<MenuItem key={2} value={"wrong contacts"} primaryText="Wrong contacts" />
								<MenuItem key={3} value={"request sent"} primaryText="Request sent" />
								<MenuItem key={4} value={"request received"} primaryText="Request received" />
								<MenuItem key={5} value={"not interested"} primaryText="Not interested" />
								<MenuItem key={6} value={"no response"} primaryText="No response" />
								<MenuItem key={7} value={"quote in progress"} primaryText="Quote in progress" />
								<MenuItem key={8} value={"quote received"} primaryText="Quote received" />
								<MenuItem key={9} value={"chosen"} primaryText="Chosen" />
								<MenuItem key={10} value={"work in progress"} primaryText="Work in progress" />
								<MenuItem key={11} value={"done"} primaryText="Done" />
							</SelectField>
						</div>
						<div className="logical-block" style={{padding:"0 20pt"}}>
							<DatePicker
								style={{textAlign: "left"}}
								hintText="Select due date"

								defaultDate={date}
								onChange={(e, value)=>{this.props.STAGE({_id: quoteId, date: value})}}
							/>
						</div>
						{(quote.expenses && quote.expenses.length)?
							<div className="logical-block" style={{padding:"0 20pt"}}>
								<TaskList tasks={quote.expenses} edit={false} />
								<RaisedButton
									label="Create bill"
									backgroundColor	= "#35ba9a"
									labelColor="#FFF"
									style={{margin:"0 20px"}}
									onClick={() => {
										let id = new Date().valueOf().toString()
										this.props.history.push(`/manager/transactions/${id}`)
										this.props.NEW({
											_id: id
											, vendor: repairman.firstName
											, vendorID: repairmanId
											, isPaid: "false"
											, address: repairman.address
											, date: new Date()
											, dueDate: new Date()
											, expenses: R.map(item => ({
												category: "70000 Property Expenses:70030 Cleaning and maintenance"
											  , memo: item.name
											  , amount: item.amount
											}),quote.expenses)
											, accountNumber: repairman.accountNumber || "Lumand"
											, amount: total
											, memo: project.title
											, type: "transaction/bill"
											, managerID: props.login
											, propertyID: (property)? property._id : 'All properties'
											, propertyAlias: (property)? property.alias : 'All properties'
											, readyToPay: false
											, comments: []
											, paymentMethod: "QuickBooks"
										})
									}}
								/>
							</div>
							:
							<div className="logical-block">
								<p style={{color: "#A0A0A0"}}>No quotes</p>
								<RaisedButton
									label="Edit"
									backgroundColor	= "#35ba9a"
									labelColor="#FFF"
									onClick={() => {
										window.open(url+"repair/project/" + project._id + "/quote/?phoneNumber=" + repairman.phoneNumber)
									}}
								/>
							</div>
						}
						<div className="logical-block">
							<p id="description"
								data-tip=''
								data-for='test'
								style={{
									cursor: 'pointer'
								}}
							>
								Property address: {(props.property)? props.property.address : 'All properties'} <br />
								<a
									href={url+"repair/project/"+project._id+"/?phoneNumber="+repairman.phoneNumber}
									target="_blank"
								>Personalized project link</a>
								<br />

								Manager phone: {(props.manager && props.manager.cellNumber)? props.manager.cellNumber: "no phone number"}
							</p>
							<ReactTooltip id="test" type="info" effect="solid" event="mouseover" eventOff="dblclick" globalEventOff="click scroll">
								<div>
									<a
										style={{
											pointerEvents: "all"
										  , textDecoration: "none"
										  , color: "inherit"
										  , cursor: "pointer"
										  , marginRight: "10px"
										}}
										href={`mailto:?subject=Your personalized link&body=Property address: ${(props.property)? props.property.address : 'All properties'}  %0D%0A%0D%0A Personalized project link ${url+"repair/project/"+project._id+"/?phoneNumber="+repairman.phoneNumber.replace(/\s|-|[A-Za-z]|\(|\)/g, '')} %0D%0A%0D%0A Manager phone: ${(props.manager && props.manager.cellNumber)? props.manager.cellNumber: "no phone number"}`}
										title="Send email"
									>
										<i className="material-icons">email</i>
									</a>
									<a
										style={{
											pointerEvents: "all"
										  , cursor: "pointer"
										  , marginRight: "10px"
										}}
										onClick={(evt)=>{
											evt.preventDefault()
											var textArea = document.createElement("textarea");
											textArea.style.position = 'fixed';
											textArea.style.top = 0;
											textArea.style.left = 0;
											textArea.style.width = '2em';
											textArea.style.height = '2em';
											textArea.style.padding = 0;
											textArea.style.border = 'none';
											textArea.style.outline = 'none';
											textArea.style.boxShadow = 'none';
											textArea.style.background = 'transparent';
											textArea.value = url+"repair/project/"+project._id+"/?phoneNumber="+repairman.phoneNumber.replace(/\s|-|[A-Za-z]|\(|\)/g, '');
											document.body.appendChild(textArea);
											textArea.select();

											try {
												var successful = document.execCommand('copy');
												var msg = successful ? 'successful' : 'unsuccessful';
												console.log('Copying text command was ' + msg);
											} catch (err) {
												console.log('Oops, unable to copy');
											}

											document.body.removeChild(textArea);
											// ReactTooltip.hide(findDOMNode(this.refs.foo))
											return false
										}}
										title="Copy link only"
									>
										<i className="material-icons">link</i>
									</a>
									<a
										style={{
											pointerEvents: "all"
										  , cursor: "pointer"
										}}
										onClick={(evt)=>{
											evt.preventDefault()
											var textArea = document.createElement("textarea");
											textArea.style.position = 'fixed';
											textArea.style.top = 0;
											textArea.style.left = 0;
											textArea.style.width = '2em';
											textArea.style.height = '2em';
											textArea.style.padding = 0;
											textArea.style.border = 'none';
											textArea.style.outline = 'none';
											textArea.style.boxShadow = 'none';
											textArea.style.background = 'transparent';
											textArea.value = `Property address: 5003 Oak Pasture Ln, Charlotte, NC 28269\nPersonalized project link ${url+"repair/project/"+project._id+"/?phoneNumber="+repairman.phoneNumber.replace(/\s|-|[A-Za-z]|\(|\)/g, '')}\nManager phone: (417) 693-4582`
											document.body.appendChild(textArea);
											textArea.select();

											try {
												var successful = document.execCommand('copy');
												var msg = successful ? 'successful' : 'unsuccessful';
												console.log('Copying text command was ' + msg);
											} catch (err) {
												console.log('Oops, unable to copy');
											}

											document.body.removeChild(textArea);
											// ReactTooltip.hide(findDOMNode(this.refs.foo))
											return false
										}}
										title="Copy link with text"
									>
										<i className="material-icons">content_copy</i>
									</a>
								</div>
							</ReactTooltip>
						</div>
						<div
							className="logical-block"
							style={{
								  display: "flex"
								, justifyContent: "flex-end"
							}}
						>
							<RaisedButton
								label="Cancel"
								style={{margin:"0 20px"}}
								onClick={() => {
									this.props.ROLLBACK()
									props.history.goBack()
								}}
							/>
							<RaisedButton
								label="OK"
								backgroundColor	= "#35ba9a"
								labelColor="#FFF"
								style={{margin:"0 20px"}}
								onClick={() => {
									this.props.COMMIT()
									props.history.goBack()
								}}
							/>
						</div>
					</div>
				}
				</div>
			</div>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}

}
export default connect(select, R.mergeAll([dataActions, attachmentActions, attachmentOverlayActions, newCommentActions, rightStackActions, actionBarActions, routerActions]))(QuoteForm)



// WEBPACK FOOTER //
// ./src/routes/manager/quoteForm/index.js